import { useState } from 'react';

export default function Testimonials() {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'Small Business Owner',
      content: 'Advanced Benefit Designs helped us create a comprehensive benefits package that our employees love. Their expertise in tax-free retirement planning has been invaluable.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/f7c016e10c095e910bcf503356144ac1.jpg'
    },
    {
      name: 'Michael Chen',
      role: 'Retiree',
      content: 'The long-term care planning service gave us peace of mind. Kevin and his team took the time to understand our needs and created a plan that works perfectly for our family.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20headshot%20portrait%20smiling%20confident%20in%20business%20attire%20modern%20office%20natural%20lighting&width=200&height=200&seq=test-002&orientation=squarish'
    },
    {
      name: 'Jennifer Martinez',
      role: 'HR Director',
      content: 'Working with Advanced Benefit Designs has transformed how we approach employee benefits. Their business preservation strategies have protected our company\'s future.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20woman%20headshot%20portrait%20smiling%20confident%20hr%20director%20in%20business%20attire%20modern%20office&width=200&height=200&seq=test-003&orientation=squarish'
    },
    {
      name: 'Robert Williams',
      role: 'Family Man',
      content: 'The mortgage protection plan they set up for us ensures our family home is secure no matter what happens. Highly recommend their personalized approach.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20caucasian%20man%20headshot%20portrait%20smiling%20confident%20family%20oriented%20businessman%20in%20casual%20business%20attire&width=200&height=200&seq=test-004&orientation=squarish'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            What Our <span className="text-teal-600">Clients Say</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Real stories from real people who trust us with their financial future.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          {/* Main Testimonial */}
          <div className="bg-white rounded-2xl shadow-xl p-12 border border-slate-100">
            <div className="flex flex-col md:flex-row gap-8 items-center md:items-start">
              <div className="flex-shrink-0">
                <img
                  src={testimonials[currentIndex].image}
                  alt={testimonials[currentIndex].name}
                  className="w-24 h-24 rounded-full object-cover border-4 border-teal-500 shadow-lg"
                />
              </div>
              <div className="flex-1 text-center md:text-left">
                <div className="flex justify-center md:justify-start gap-1 mb-4">
                  {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>
                <p className="text-lg text-slate-700 leading-relaxed mb-6 italic">
                  "{testimonials[currentIndex].content}"
                </p>
                <div>
                  <h4 className="text-xl font-bold text-slate-900">{testimonials[currentIndex].name}</h4>
                  <p className="text-teal-600 font-medium">{testimonials[currentIndex].role}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-center gap-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 flex items-center justify-center rounded-full bg-white border-2 border-slate-200 text-slate-600 hover:border-teal-500 hover:text-teal-600 transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>
            <button
              onClick={nextTestimonial}
              className="w-12 h-12 flex items-center justify-center rounded-full bg-white border-2 border-slate-200 text-slate-600 hover:border-teal-500 hover:text-teal-600 transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex ? 'bg-teal-600 w-8' : 'bg-slate-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
